import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { OltListPage } from '@/features/monitoring'

export const Route = createFileRoute('/_authenticated/monitoring/olts')({
  component: () => (
    <RequirePermission permission='monitoring.read'>
      <OltListPage />
    </RequirePermission>
  ),
})
